import styled from 'styled-components';

export const Outer = styled.select`
  padding: 10px 15px;
  outline: none;
  border: none;
  font-size: 1rem;
`;
